<template>
  <div class="page">
    <SearchNav />
    <div class="page-content">
      <div class="page-title-container">
        <img class="page-icon" :src="require('@/assets/img/logo.png')" />
        <div class="page-title">在线支付</div>
      </div>
      <div class="content-card-success" v-if="paymentStatus === 'SUCCESS'">
        <img class="success-icon" :src="require('@/assets/pay/payment-success.png')" />
        <div class="success-description">支付成功</div>
        <a class="a-button" @click="goBack">返回</a>
      </div>
      <div class="content-card" v-else>
        <div class="description">
          请在
          <span>{{ expireTime }}</span>
          前支付
        </div>
        <div class="scan-desc">请直接用微信扫一扫支付，受微信官方限制，不支持截图转发</div>
        <div class="qr-code-container">
          <div class="left">
            <img class="qr-code" :src="payQRCode"/>
            <img class="qr-code-description" :src="require('@/assets/pay/scan.png')" />
          </div>
          <img class="qr-code-image-description" :src="require('@/assets/pay/wechat-scan.png')" />
        </div>
        <a class="a-button" @click="goBack">返回</a>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/components/SearchNav/index.vue'
import { getTradeInfo } from '@zyf2e/checkout-sdk'
import * as api from '@/services'
import dayjs from 'dayjs'

let _t // 二维码倒计时
let _queryT // 支付结果查询倒计时

export default {
  name: 'OnlinePayment',
  components: { SearchNav },
  data() {
    return {
      paymentStatus: '', // SUCCESS-成功
      payQRCode: null, // 支付二维码
      countdown: 0,
      expireTime: '-',
    }
  },
  computed: {
    orderSn() {
      return this.$route.params.orderSn;
    },
    tradeNo() {
      return this.$route.params.tradeNo;
    },
  },
  beforeDestroy() {
    clearInterval(_t)
    clearInterval(_queryT)
    _t = null
    _queryT = null
  },
  mounted() {
    this.init()
    this.queryPaymentResult()
  },
  methods: {
    async init() {
      // 调用支付SDK，获取支付二维码
      try {
        const res = await this.$zyPay.getPayQRCode(this.tradeNo)
        this.payQRCode = res.wechat
        const tradeInfo = await getTradeInfo(this.tradeNo)
        this.expireTime = dayjs(tradeInfo.data.expireTime).format('YYYY-MM-DD HH:mm:ss')

        // const { payStringJson } = res
        // const countTime = Math.floor(parseInt(payStringJson.time_stamp) - payStringJson.serverTimeSecond)
        // this.countdown = countTime
        // _t = setInterval(() => {
        //   if (this.paymentStatus === 'SUCCESS') {
        //     clearInterval(_t)
        //     return
        //   }
        //   if (this.countdown < 1) {
        //     clearInterval(_t)
        //     this.init()
        //   }
        //   if (this.countdown > 0) {
        //     this.countdown = this.countdown - 1
        //   }
        // }, 1000)
      } catch (e) {
        console.error(e)
      }
    },
    async queryPaymentResult() {
      _queryT = setInterval(async () => {
        const res = await api.order.queryPayResult({ tradeNo: this.tradeNo })
        if (res.data.tradeStatus === 1) {
          // 支付成功
          this.paymentStatus = 'SUCCESS'
          clearInterval(_queryT)
        }
      }, 3000)
    },
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  //height: calc(100% - 34px);
}
.page-content {
  width: 100%;
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 40px);
}
.page-title-container {
  display: flex;
  width: 1190px;
  margin: 16px 0;
  .page-icon {
    width: 81px;
    height: 24px;
    margin-right: 8px;
  }
  .page-title {
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
  }
}
.content-card-success {
  width: 1190px;
  height: 759px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  .success-icon {
    width: 48px;
    height: 48px;
    margin-bottom: 23px;
  }
  .success-description {
    font-size: 24px;
    line-height: 24px;
    font-weight: 500;
    color: #333333;
  }
  .a-button {
    position: absolute;
    bottom: 44px;
  }
}
.content-card {
  width: 1190px;
  height: 759px;
  background: #ffffff;
  border-radius: 8px;
  padding: 27px 24px 44px 24px;
  margin-bottom: 54px;
  .description {
    font-size: 18px;
    color: #333333;
    line-height: 18px;
    margin-bottom: 19px;
    span {
      color: #ff000d;
    }
  }
  .qr-code-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 37px;
    .left {
      display: flex;
      flex-direction: column;
      margin-right: 75px;
      .qr-code {
        width: 389px;
        height: 389px;
        border: 1px solid #c3c3c3;
        background: #ffffff;
        margin-bottom: 18px;
      }
      .qr-code-description {
        width: 389px;
        height: 84px;
      }
    }
    .qr-code-image-description {
      width: 403px;
      height: 576px;
    }
  }
}
.a-button {
  display: block;
  width: 100%;
  text-align: center;
  font-size: 18px;
  line-height: 18px;
  color: #1e8dff;
  cursor: pointer;
}
.scan-desc {
  color: red;
  font-weight: 500;
  font-size: 24px;
}
</style>

